import React from 'react';

import { CFColorTokenProp } from '../../../theme/tokens/contentful-color';

import { WidgetProps, DEFAULT_BUTTON_TEXT } from '../shared';

import { GetStartedButton } from './styles';

export interface GetStartedNoPhoneWidgetProps extends WidgetProps {
  onStartClick?: () => void;
}

export function GetStartedNoPhoneWidget({
  buttonColor = 'ginger',
  buttonHoverColor = 'green',
  buttonText = DEFAULT_BUTTON_TEXT,
  buttonContent,
  isScrolled = false
}: GetStartedNoPhoneWidgetProps) {
  return (
    <GetStartedButton
      type="submit"
      cfButtonColor={buttonColor as CFColorTokenProp}
      cfButtonHoverColor={buttonHoverColor as CFColorTokenProp}
      isScrolled={isScrolled}
      aria-label="Get started"
      data-testid="get-started-button"
    >
      {buttonContent || buttonText}
    </GetStartedButton>
  );
}
